import { render, staticRenderFns } from "./V2CheckboxItem.vue?vue&type=template&id=367a1a39&scoped=true&"
import script from "./V2CheckboxItem.vue?vue&type=script&lang=js&"
export * from "./V2CheckboxItem.vue?vue&type=script&lang=js&"
import style0 from "./V2CheckboxItem.vue?vue&type=style&index=0&id=367a1a39&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367a1a39",
  null
  
)

export default component.exports